import { Menu as RAMenu, usePermissions } from 'react-admin';
import {
    Build as BuildIcon,
    History as AuditIcon,
    Dashboard as DashboardIcon,
    Key as KeyIcon,
    People as PeopleIcon,
    ViewQuilt as TemplateIcon,
} from '@mui/icons-material';

export const Menu = () => {
    const { permissions } = usePermissions();

    return (
        <RAMenu>
            <RAMenu.Item to="/" primaryText="Dashboard" leftIcon={<DashboardIcon/>}/>
            {permissions?.includes('clients:read') && (
                <RAMenu.Item
                    to="/clients"
                    primaryText="Clients"
                    leftIcon={<PeopleIcon/>}
                />
            )}
            {permissions?.includes('clients:read') && (
                <RAMenu.Item
                    to="/templates"
                    primaryText="Templates"
                    leftIcon={<TemplateIcon/>}
                />
            )}
            {permissions?.includes('secrets:write') && (
                <RAMenu.Item
                    to="/shared-secrets"
                    primaryText="Shared Secrets"
                    leftIcon={<KeyIcon/>}
                />
            )}
            {permissions?.includes('builds:read') && (
                <RAMenu.Item
                    to="/builds"
                    primaryText="Builds"
                    leftIcon={<BuildIcon/>}
                />
            )}
            {permissions?.includes('secrets:write') && (
                <RAMenu.Item
                    to="/audit"
                    primaryText="Audit"
                    leftIcon={<AuditIcon/>}
                />
            )}

            {/*{permissions?.includes('metrics:read') && (*/}
            {/*  <RAMenu.Item*/}
            {/*    to="/metrics"*/}
            {/*    primaryText="Metrics"*/}
            {/*    leftIcon={<AssessmentIcon />}*/}
            {/*  />*/}
            {/*)}*/}
        </RAMenu>
    );
};
